import { metricKeys } from '@pulse/metrics';
import { getDistributionMetrics } from '@components/metrics-panel-hz/utils/metricsMapping';
import { DATASET } from '@utils/constants';

export const NETWORK_REQUEST_RESPONSE_CODE_DIMENSION = 'network_request_response_code';

const colorOperator = (hexColor, shadeAmount) => {
  hexColor = hexColor.replace(/#/, '');
  const r = parseInt(hexColor.slice(0, 2), 16);
  const g = parseInt(hexColor.slice(2, 4), 16);
  const b = parseInt(hexColor.slice(4, 6), 16);
  const newR = Math.max(0, Math.min(255, Math.round(r * shadeAmount)));
  const newG = Math.max(0, Math.min(255, Math.round(g * shadeAmount)));
  const newB = Math.max(0, Math.min(255, Math.round(b * shadeAmount)));
  // tslint:disable-next-line:no-bitwise
  return `#${((newR << 16) | (newG << 8) | newB).toString(16).padStart(6, '0')}`;
};

// make a color darker or lighter
export const adjustColor = (hexColor, percent) => {
  const shadeAmount = 1 - percent / 100;
  return colorOperator(hexColor, shadeAmount);
};

export const DURATION_BUCKET_COLOR = {
  '0-0.1': '#4CAF50', // [0, 0.1) seconds: Dark Green
  '0.1-0.5': '#8BC34A', // [0.1, 0.5) seconds: Light Green
  '0.5-1': '#CDDC39', // [0.5, 1) seconds: Lime
  '1-2': '#FF9800', // [1, 2) seconds: Orange
  '2-3': '#FF5722', // [2, 3) seconds: Deep Orange
  '3-5': '#F44336', // [3, 5) seconds: Red
  '5-10': '#F44336', // [5, 10) seconds: Red
  '>=10': '#FF0000', // >=10 seconds: Darker Red
};

export const DURATION_BUCKET = [0.1, 0.5, 1, 2, 3, 5, 10]; // in seconds

export const STACK_COLOR_CODE = {
  0: '#000000',
  1: '#CDDC39',
  2: '#4CAF50',
  3: '#FF9800',
  4: '#F44336',
  5: '#FF0000',
};

export const getErrorCodeFilter = (errorCodeList = []) => {
  return errorCodeList.map((code) => ({
    _order: 0,
    display: code,
    field: NETWORK_REQUEST_RESPONSE_CODE_DIMENSION,
    key: null,
    op: 'eq',
    originalField: NETWORK_REQUEST_RESPONSE_CODE_DIMENSION,
    value: code,
  }));
};

export const timeseriesQuery = {
  type: 'timeseries',
  dataset: DATASET,
  metrics: [], // append metric name selected in metrics panel
  interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
  granularity: 'ALL',
  filter: [],
  isLiveMode: false,
  options: {
    withTotals: true,
  },
};

export const groupByQuery = {
  type: 'group-by',
  dataset: DATASET,
  metrics: [], // append metric name selected in metrics panel
  interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
  granularity: 'ALL',
  filter: [],
  limit: 25,
  groupBy: [
    '', // dimension name
  ],
  orderBy: 'desc',
  sortBy: [{ metric: 'Plays', order: 'desc' }],
  options: {
    withTotals: true,
  },
};

/** ardd is abbreviation for AverageRequestDuration Distribution */
const {
  metric: arddMetric = 'total_request_count',
  dimension: arddDimension = 'avg_request_duration_distribution',
} = getDistributionMetrics()?.[metricKeys.AverageRequestDuration]?.[0] ?? {};
export { arddMetric, arddDimension };
